// extracted by mini-css-extract-plugin
export default {"suggestions":"wuqraH","label":"Gf9yb8","suggestionLink":"DVijBz","active":"ppkib0"};